// Base imports for rails
import * as Ujs from '@rails/ujs'
import * as Turbolinks from 'turbolinks'
import * as ActiveStorage from '@rails/activestorage'
Ujs.start()
Turbolinks.start()
ActiveStorage.start()
import 'channels'

// Stylesheets for tailwind components
import 'stylesheets'

// Vendor imports
import 'chart.js'
import 'sweetalert'
import '@fortawesome/fontawesome-free/js/all'
import 'chartkick'
import jQuery from 'jquery'
window.jQuery = window.$ = jQuery

// Stimulus
import 'controllers'

// Images pack tag
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

